import { render, staticRenderFns } from "./SelectUserModal.vue?vue&type=template&id=2a84e55c&scoped=true"
import script from "./SelectUserModal.vue?vue&type=script&lang=js"
export * from "./SelectUserModal.vue?vue&type=script&lang=js"
import style0 from "./SelectUserModal.vue?vue&type=style&index=0&id=2a84e55c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84e55c",
  null
  
)

export default component.exports